( () => {
	const BLOCK_CLASS = 'wp-block-phrase-com-bento-box-slider';
	const blocks = document.querySelectorAll( `.${ BLOCK_CLASS }` );
	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		const slides = block.querySelectorAll( '.wp-block-phrase-com-bento-box-slide' );
		if ( ! slides.length ) {
			return;
		}

		const headerImages = block.querySelectorAll( `.${ BLOCK_CLASS }__header-image` );

		// Show the first header image by default.
		if ( headerImages.length ) {
			headerImages[ 0 ].classList.add( 'is-active' );
		}

		// Add hover event listeners to each slide.
		slides.forEach( ( slide, index ) => {
			slide.addEventListener( 'mouseenter', () => {
				// Show the corresponding header image.
				headerImages.forEach( ( hi ) => hi.classList.remove( 'is-active' ) );
				if ( headerImages[ index ] ) {
					headerImages[ index ].classList.add( 'is-active' );
				}

				// Dim sibling slides.
				slides.forEach( ( s ) => s.classList.remove( 'is-hovered' ) );
				slide.classList.add( 'is-hovered' );
				block.classList.add( 'has-hover' );
			} );
		} );

		// Reset on mouse leave from the slides container.
		const slidesContainer = block.querySelector( `.${ BLOCK_CLASS }__slides` );
		if ( slidesContainer ) {
			slidesContainer.addEventListener( 'mouseleave', () => {
				slides.forEach( ( s ) => s.classList.remove( 'is-hovered' ) );
				block.classList.remove( 'has-hover' );

				// Show the first header image again.
				headerImages.forEach( ( hi ) => hi.classList.remove( 'is-active' ) );
				if ( headerImages.length ) {
					headerImages[ 0 ].classList.add( 'is-active' );
				}
			} );
		}
	} );
} )();
